import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { LookupService } from '../../../services/lookup.service';
import { KeyValueObject } from '../../../models/core/KeyValueObject';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { UserGroupsService } from '../../../services/user-groups.service';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { WorkflowTransition } from '../../../models/request/workflow-transition';
import { PerformerUserContragentsService } from '../../../services/performer-user-contragents.service';
import { PerformerUserContragent } from '../../../models/contragent/performer-user-contragent';
import { ActivitiesService } from '../../../services/activities.service';
import { ActivityPerformerSlotsConfirmationComponent } from '../activity-performer-slots-confirmation/activity-performer-slots-confirmation.component';
import { DevicesService } from '../../../services/devices.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { RequestsService } from '../../../services/requests.service';
import { NotificationType } from '../../../../core/services/notification-type';
import { ActivityType } from '../../../enums/activity-type.enum';
import { UsersService } from '../../../../admin/users/users.service';
import { SetPerformerUserGroupModel } from '../set-performer-user-group/set-performer.model';
import { PlannedDayContext } from '../../engineer-visit-planning/engineer-visit-planning.component';

@Component({
    selector: 'set-performer-engineer-user-group',
    templateUrl: './set-performer-engineer-user-group.html',
	styleUrls: ['./set-performer-engineer-user-group.scss']
})
export class SetPerformerEngineerUserGroup implements OnInit {

    @Input() isPerformerUserGroupVisible: boolean = true;
    @Input() setPerformerUserGroupModel: SetPerformerUserGroupModel;
    @Input() workflowTransition: WorkflowTransition;
    @Input() requestId: number;
    @Input() requestContragentId: number;
    @Input() requestIntegraCode: string;
    @Input() requestServiceCenterId: number;
    @Input() requestServiceCenterIntegraCode: string;
    @Input() disablePerformerSelection: boolean = false;

    @Output() onContinueEvent = new EventEmitter<SetPerformerUserGroupModel>();
    @Output() onCancelEvent = new EventEmitter();

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    protected userGroupContragentId?: number;
    useManualPlanning: boolean = false;

    selectedServiceCenterId: number;

    constructor(
        private activitiesService: ActivitiesService,
        private lookupService: LookupService,
        private dialogService: DialogService,
        public dialog: DialogRef,
        private userGroupsService: UserGroupsService,
        private performerUserContragentsService: PerformerUserContragentsService,
        private devicesService: DevicesService,
        private requestsService: RequestsService,
        private notificationService: NotificationService,
        private usersService: UsersService
    ) { }

    ngOnInit() {
    }

    cancel() {
        this.onCancelEvent.emit();
        this.dialog.close();
    }

    continue(context: PlannedDayContext) {
        this.setPerformerUserGroupModel.userId = context.performerId;
        this.setPerformerUserGroupModel.planStartDate = context.visitDate;

        if (this.useManualPlanning && this.setPerformerUserGroupModel.userId != null) {
            this.activitiesService.checkActivityPerformerSlots(this.setPerformerUserGroupModel.userId, this.setPerformerUserGroupModel.planStartDate).subscribe(resp => {
                // раньше была сортировка по requestId (все неравные текущему)
                let otherActivitySlots = resp.data;

                if (otherActivitySlots.length > 0) {
                    const dialogRef = this.dialogService.open({
                        title: `На это время у инж уже есть назначенные заявки`,
                        content: ActivityPerformerSlotsConfirmationComponent
                    });

                    const dialog = <ActivityPerformerSlotsConfirmationComponent>dialogRef.content.instance;
                    dialog.activityPerformerSlots = otherActivitySlots;

                    dialog.onCancelEvent.subscribe(() => {
                        dialogRef.close();
                    });
                    dialog.onContinueEvent.subscribe(() => {
                        dialogRef.close();
                        this.continueStep1();
                    });
                } else {
                    this.continueStep1();
                }
            });
        } else {
            this.continueStep1();
        }
    }
    continueStep1() {
        if (this.useManualPlanning && this.setPerformerUserGroupModel.userId != null) {
            this.requestsService.getRequestsTotalTime({
                activityInfo: {
                    requestId: this.requestId,
                    activityTypeId: this.getActivityTypeIdByUserGroupId(this.setPerformerUserGroupModel.userGroupId)
                },
                userIds: [this.setPerformerUserGroupModel.userId],
                date: this.setPerformerUserGroupModel.planStartDate
            }).subscribe(x => {
                if (!x.isSuccessful) {
                    this.notificationService.error({
                        title: 'Ошибка',
                        message: x.errorDescription,
                        notificationType: NotificationType.SweetAlert
                    });
                } else {
                    if (x.data[0].isCapacityExceeded) {
                        this.notificationService.confirmation({
                            title: 'Предупреждение',
                            enableHtml: true,
                            message: `Обнаружена попытка назначить активность на сотрудника с превышением запаса рабочего времени. Продолжить?`,
                            type: 'question',
                            confirmButtonText: 'Продолжить',
                            cancelButtonText: 'Отмена',
                            showCloseButton: false
                        },
                        () => {
                            this.continueStep2();
                        },
                        () => {
                            
                        });
                    } else {
                        this.continueStep2();
                    }
                }
            });
        } else {
            this.continueStep2();
        }
    }
    
    getActivityTypeIdByUserGroupId(userGroupById: number): number{
        switch (userGroupById) {
            // монтаж
            case 11:
                return <number>ActivityType.techSupport;
            // специалисты
            case 331:
                return <number>ActivityType.inspection;
        }
    }

    continueStep2() {
        if (this.useManualPlanning && this.setPerformerUserGroupModel.userId != null) {
            this.devicesService.getDevicesNotOnOwnStock(this.setPerformerUserGroupModel.userId, this.requestId).subscribe(x => {
                if (x.length > 0) {
                    this.notificationService.confirmation({
                        title: 'Предупреждение',
                        enableHtml: true,
                        message: `Устройства по заявке:<br>
                    ${x.join('<br>')}<br>
                    отсутствуют на складе выбранного монтажника, а так же на центральном складе.<br>
                    Продолжить?`,
                        type: 'question',
                        confirmButtonText: 'Продолжить',
                        cancelButtonText: 'Отмена',
                        showCloseButton: false
                    },
                        () => {
                            this.onContinueEvent.emit(this.setPerformerUserGroupModel);
                            this.dialog.close();
                        },
                        () => {
                            
                        });
                } else {
                    this.onContinueEvent.emit(this.setPerformerUserGroupModel);
                    this.dialog.close();
                }
            })
        } else {
            this.onContinueEvent.emit(this.setPerformerUserGroupModel);
            this.dialog.close();
        }
    }
}
